import React, { useState, useEffect, useCallback } from 'react';
import { FaStar } from 'react-icons/fa';
import profilephoto from '../../assets/profile_icon.png';
import point_icon from '../../assets/point.png';

const DescriptionBox = (props) => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const { product } = props;
  const [activeTab, setActiveTab] = useState('description');
  const [allReviews, setAllReviews] = useState(product.reviewText);
  const [review, setReview] = useState('');
  const [rating, setRating] = useState(null);
  const [hover, setHover] = useState(null);

  useEffect(() => {
    if (product && product.reviewText) {
      setAllReviews(product.reviewText);
    }
  }, [product]);

  const handleTabClick = (tab) => {
    if (tab === 'reviews' && !product.available) {
      alert('You cannot view reviews for an unavailable product.');
      return;
    }
    setActiveTab(tab);
  };

  const reviewHandler = (e) => {
    setReview(e.target.value);
  };

  const addReview = useCallback(() => {
    if (rating) {
      const newReview = {
        itemId: product.id,
        rating: rating ? rating : 0,
        text: review ? review : 'No review',
      };
      setAllReviews((prevReviews) => [newReview, ...prevReviews]);
      if (localStorage.getItem('auth-token')) {
        fetch(`${databaseUrl}/addreview`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newReview),
        })
          .then((response) => response.json())
          .then((data) => console.log(data));
      }
      setReview('');
      setRating(null);
    }
  }, [product, rating, review]);

  return (
    <div className="flex flex-col p-4 mt-10 md:mt-20 px-4 md:px-[10%]">
      <div className="flex shadow-md gap-4 md:gap-10 items-center justify-center">
        <button
          className={`px-2 py-3 md:px-4 md:py-5 ${activeTab === 'description' ? 'border-b-2 border-[#551E19] text-[#551E19]' : 'text-gray-700'}`}
          onClick={() => handleTabClick('description')}
        >
          Description
        </button>
        <button
          className={`px-2 py-3 md:px-4 md:py-5 ${activeTab === 'reviews' ? 'border-b-2 border-[#551E19] text-[#551E19]' : 'text-gray-700'}`}
          onClick={() => handleTabClick('reviews')}
        >
          Reviews ({product.no_of_rators})
        </button>
      </div>

      <div className="mt-4">
        {activeTab === 'description' && product.description && (
          <div className="p-4 bg-white shadow rounded-md">
            <div>
              {product.description.formatted_text ? (
                <p className="mb-2 text-gray-800">{product.description.formatted_text}</p>
              ) : (
                <p className="mb-2 text-gray-800 text-center">No description available ...</p>
              )}

              {product.description.bullet_points && product.description.bullet_points.length > 0 && (
                <ul className="pl-5 text-gray-800">
                  {product.description.bullet_points.map((point, index) => (
                    <li key={index} className='flex items-center gap-4'>
                      <img src={point_icon} alt='point' className='w-4 h-4' />
                      {point}
                    </li>
                  ))}
                </ul>
              )}

              {product.description.plain_text && (
                <p className="mt-2 text-gray-800">{product.description.plain_text}</p>
              )}
            </div>
          </div>
        )}

        {activeTab === 'reviews' && (
          <div className="space-y-4">
            <div className="p-4 bg-white shadow rounded-md">
              <p className="mb-2 text-[#551E19] font-semibold">Rate this product</p>
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, index) => {
                  const currentRating = index + 1;
                  return (
                    <label key={index}>
                      <input
                        type="radio"
                        name="rating"
                        value={currentRating}
                        className="hidden"
                      />
                      <FaStar
                        className="cursor-pointer w-5 h-5"
                        size={25}
                        color={currentRating <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
                        onMouseEnter={() => setHover(currentRating)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(currentRating)}
                      />
                    </label>
                  );
                })}
              </div>
              <textarea
                value={review}
                placeholder="Add your review..."
                onChange={reviewHandler}
                className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:ring-[#551E19]"
              />
              <button
                onClick={addReview}
                className="mt-2 px-4 py-2 bg-[#551E19] text-white rounded-md hover:bg-[#551E19]"
              >
                Submit Review
              </button>
            </div>

            <div>
              {allReviews.slice(0, product.no_of_rators + 1).map((reviewItem, i) => (
                <div key={i} className="flex items-start p-4 mb-2 bg-white shadow rounded-md">
                  <img
                    src={profilephoto}
                    alt={`Reviewer ${i + 1}`}
                    className="w-10 h-10 rounded-full mr-4"
                  />
                  <div>
                    <div className="flex space-x-1">
                      {[...Array(reviewItem.rating)].map((_, j) => (
                        <FaStar key={j} size={20} color="#ffc107" />
                      ))}
                    </div>
                    <p className="mt-1 text-gray-700">{reviewItem.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DescriptionBox;